module.exports = __webpack_public_path__ + "media/images/icons/check-square-8549fa8e596f86689759c83cf743f419.svg";